import React from 'react';
import PropTypes from 'prop-types';
import AmbGrid from '../../../common/AmbGrid';
import AmbTooltip from '../../../common/AmbTooltip/AmbTooltip';
import Info from '../../../common/icons/info/info-16px';
import AmbSwitch from 'components/common/AmbSwitch';

const BillerVerifiedFrame = ({
  prebillerVerifiedDisabled,
  billerVerifiedChange,
  isBillerVerified,
  isBillerVerifiedTooltip,
  billerVerifiedAt,
  billerVerifiedBy,
  loadedRequest,
  coverageRequired,
  eaRunStatusWarning,
}) => {
  const prebillerStyles = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    margin: '20px -12px 0 -12px',
    borderTop: 'rgba(0, 0, 0, 0.09) 1px solid',
    maxWidth: 'inherit',
    backgroundColor: '#f7f7f7',
    padding: 10,
  };

  const bgColor = isBillerVerified
    ? { backgroundColor: '#f3fcf9', borderLeft: '#33cc99 2px solid', borderRight: '#33cc99 2px solid' }
    : { backgroundColor: '#fff5f5', borderLeft: '#ff5252 2px solid', borderRight: '#ff5252 2px solid' };

  const getPrebillerStyles = () => {
    if (loadedRequest && coverageRequired) {
      return {
        ...prebillerStyles,
        ...bgColor,
      };
    }
    return prebillerStyles;
  };
  const blockingReason = prebillerVerifiedDisabled ? isBillerVerifiedTooltip.split('\n')[0] : '';
  const statusMessage = [blockingReason, eaRunStatusWarning].filter(Boolean).join('\n');
  const prebillerLabelStyles = prebillerVerifiedDisabled ? { opacity: 0.5 } : {};

  return (
    <AmbGrid style={getPrebillerStyles()}>
      <div style={{ flex: 1, minWidth: 0 }}>
        <AmbTooltip
          title={prebillerVerifiedDisabled ? isBillerVerifiedTooltip : ''}
          placement="top"
          describeChild
          componentsProps={{ tooltip: { sx: { whiteSpace: 'pre-line' } } }}
        >
          <span style={{ display: 'inline-flex' }}>
            <label id="prebiller-verified-label" style={prebillerLabelStyles}>
              <AmbSwitch
                id="prebiller-verified-switch"
                disabled={prebillerVerifiedDisabled}
                onChange={e => billerVerifiedChange(e.target.checked)}
                checked={isBillerVerified}
              />
              PREBILLER VERIFIED
            </label>
          </span>
        </AmbTooltip>
      </div>
      {isBillerVerifiedTooltip && (
        <AmbTooltip
          id="prebiller-tooltip"
          title={isBillerVerifiedTooltip}
          placement="top"
          describeChild
          componentsProps={{ tooltip: { sx: { whiteSpace: 'pre-line' } } }}
        >
          <button
            type="button"
            aria-label="Prebiller Verified details"
            style={{
              display: 'inline-flex',
              flexShrink: 0,
              background: 'none',
              border: 0,
              padding: 2,
              marginLeft: 8,
              cursor: 'help',
            }}
          >
            <Info />
          </button>
        </AmbTooltip>
      )}
      {isBillerVerified && (
        <div
          id="prebiller-verified-by"
          style={{
            minWidth: 0,
            marginLeft: 8,
            fontSize: 12,
            textAlign: 'right',
            opacity: 0.8,
            lineHeight: 1,
            overflowWrap: 'anywhere',
          }}
        >
          <div>{`as of ${billerVerifiedAt}`}</div>
          <div>{`by ${billerVerifiedBy}`}</div>
        </div>
      )}
      {statusMessage && (
        <div
          role="status"
          style={{
            flexBasis: '100%',
            minWidth: 0,
            marginTop: 6,
            fontSize: 12,
            lineHeight: '18px',
            color: '#555',
            overflowWrap: 'anywhere',
            whiteSpace: 'pre-line',
          }}
        >
          {statusMessage}
        </div>
      )}
    </AmbGrid>
  );
};

BillerVerifiedFrame.propTypes = {
  billerVerifiedAt: PropTypes.string,
  billerVerifiedBy: PropTypes.string,
  billerVerifiedChange: PropTypes.func.isRequired,
  loadedRequest: PropTypes.bool.isRequired,
  isBillerVerified: PropTypes.bool.isRequired,
  isBillerVerifiedTooltip: PropTypes.string.isRequired,
  prebillerVerifiedDisabled: PropTypes.bool.isRequired,
  eaRunStatusWarning: PropTypes.string,
};

BillerVerifiedFrame.defaultProps = {
  billerVerifiedAt: '',
  billerVerifiedBy: '',
  eaRunStatusWarning: '',
};

export default BillerVerifiedFrame;
